// extracted by mini-css-extract-plugin
export default {"hero":"LoreScreen_hero__yLgcz","credits":"LoreScreen_credits__rznFJ","fadeUp":"LoreScreen_fadeUp__2yFgW"};